import styled, { css } from 'styled-components'

export const LoaderWrapper = styled.div`
  display: flex;
  visibility: hidden;
  justify-content: center;
  align-items: center;

  img {
    height: 4rem;
    width: auto;
    ${({ theme }) => (theme.alternativeScheme ? `filter: grayscale(1);` : null)}
  }

  &.hidden {
    visibility: hidden;
  }

  &.visible {
    visibility: visible;
  }

  ${({ fullPage }) =>
    fullPage &&
    css`
      background-color: rgba(255, 255, 255, 0.8);
      width: 100vw;
      height: 100vh;
      position: fixed;
      inset: 0;
      z-index: 1;
    `}
`
